<template>
  <div>
    <!-- 抽屉组件 -->
    <el-drawer
      class="drawer"
      title="品类详情"
      size="40%"
      :modal="false"
      :append-to-body="true"
      :visible.sync="listDialog"
      :before-close="close">
      <div class="container">
         <el-table
          ref="multipleTable"
          :data="categoryDetailList"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{background:'#eef1f6',color:'#606266'}"
          >
          <el-table-column
            prop="type"
            label="功能类型"
            >
          </el-table-column>
          <el-table-column
            prop="name"
            label="功能名称"
            >
          </el-table-column>
          <el-table-column
            prop="identifier"
            label="标识符"
            >
          </el-table-column>
        </el-table>
      </div>
      <div class="drawer-footer">
        <div class="drawer-btn">
          <el-button
          type="primary"
          @click="close"
          >
            关闭
          </el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { getModel } from '@/api/categoryManager'
export default {
  props: {
    listDialog: {
      type: Boolean,
      default: false
    },
    categoryId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      categoryDetailList: []
    }
  },
  watch: {
    categoryId: {
      // immediate: true,
      handler (val) {
        this.getModels()
      }
    }
  },
  created () {
  },
  methods: {
    close () {
      console.log(1)
      this.$emit('close')
    },
    getModels () {
      const params = {
        categoryId: this.categoryId
      }
      getModel({ params }).then((res) => {
        console.log(res.data.data.thingModel)
        const result = res.data.data.thingModel
        let eventsList = []; let propertyList = []; let serviceList = []
        if (result.events.length > 0) {
          eventsList = result.events.map((e) => {
            const obj = {
              type: '事件'
            }
            obj.identifier = e.identifier
            obj.name = e.name
            return obj
          })
        }
        if (result.properties.length > 0) {
          propertyList = result.properties.map((e) => {
            const obj = {
              type: '属性'
            }
            obj.identifier = e.identifier
            obj.name = e.name
            return obj
          })
        }
        if (result.services.length > 0) {
          serviceList = result.services.map((e) => {
            const obj = {
              type: '服务'
            }
            obj.identifier = e.identifier
            obj.name = e.name
            return obj
          })
        }
        this.categoryDetailList = [...eventsList, ...propertyList, ...serviceList]
      })
    }
  }
}
</script>

<style lang='less' scoped>
  .drawer{
      right:30%;
      z-index: 2500 !important;
      box-shadow: 0 4px 16px 0 rgb(0 0 0 / 21%);
      /deep/ .el-drawer__header{
        line-height: 60px !important;
        font-size: 18px !important;
        height: 60px !important;
        border-bottom: 1px solid #efefef !important;
        padding: 0 24px !important;
        margin-bottom: 0 !important;
      }
      /deep/ .el-drawer__body{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .container{
          padding: 16px 24px 0 24px !important;
          margin-bottom: 64px;
          border-top: 1px solid #ececec;
          .screen{
            display: flex;
            /deep/ .el-input{
              margin-left: 0;
              width: 90%;
            }
          }
          /deep/ .el-table::before{
            background: white;
          }
          /deep/ .el-table th>.cell:first-child{
            padding: 0 14px
          }

        }
        .drawer-footer{
          position: fixed;
          background: white;
          width: 28%;
          bottom: 0;
          display: flex;
          box-sizing: border-box;
          justify-content: space-between;
          align-items: center;
          border-top: 1px solid #ececec;
          padding: 10px 24px ;
          height:64px;
          i{
            color: #409eff;
            font-style: normal;
          }
          .drawer-btn{
            .el-button{
              border-radius: 0px;
            }
          }
        }
      }
      /deep/ :focus {
        outline: 0;
      }
      .pagination-container{
        margin-top: 10px;
      }
    }
</style>
